<template>
  <div class="common-title-page">
    <div class="title-wrapper">
      <manufacturer-input ref="manufacturerInput"></manufacturer-input>
      <span class="title">Manufacturer Subscriptions</span>
    </div>
    <div class="section-title mt-20 mb-20">
      <el-button
        class="save-btn mini-btn min-w-80"
        :loading="addLoading"
        @click="add()"
        >Add</el-button
      >
      <span class="right-float">
        <img src="@/assets/filter.svg" />
        <el-input
          v-model="filter"
          size="mini"
          class="search-input filter-input"
          placeholder="filter by code"
        ></el-input>
      </span>
    </div>
    <el-table
      border
      ref="table"
      :data="tableData"
      size="small"
      v-loading="loading"
      :default-sort="{ prop: 'expiryDate', order: 'descending' }"
    >
      <el-table-column label="Subscription Code" prop="code"> </el-table-column>
      <el-table-column
        label="Status"
        prop="status"
        :filters="[
          {
            text: 'Approved',
            value: 'Approved'
          },
          {
            text: 'Trial',
            value: 'Trial'
          },
          {
            text: 'Disabled',
            value: 'Disabled'
          }
        ]"
        :filter-method="filterHandler"
      >
        <template slot-scope="scope">
          <div :class="statusFontClass(scope.row.status)">
            {{ scope.row.status }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Expiry Date" prop="expiryDateTime" sortable>
        <template slot-scope="scope">
          {{
            scope.row.expiryDateTime
              ? moment(scope.row.expiryDateTime).format('DD/MM/YYYY @ hh:mm a')
              : '--'
          }}
        </template>
      </el-table-column>
      <el-table-column label="Created Date" prop="createdDateTime" sortable>
        <template slot-scope="scope">
          {{ moment(scope.row.createdDateTime).format('DD/MM/YYYY @ hh:mm a') }}
        </template>
      </el-table-column>
      <el-table-column label="Assigned to" prop="assigedTo">
        <template>
          {{ $store.state.manufacturer.selectedManufacturer.name }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('text.action') | firstLetterCapitalize"
        min-width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status !== 'Disabled'">
            <el-button
              class="save-btn mini-btn min-w-80"
              @click="edit(scope.row)"
              >Set Expiry</el-button
            >
            <el-button
              v-if="scope.row.status === 'Trial'"
              class="save-btn mini-btn min-w-80 ml-10"
              @click="approveCode(scope.row)"
              >Set Approved</el-button
            >
          </div>
          <el-button
            class="save-btn mini-btn min-w-80"
            @click="edit(scope.row)"
            v-else
            >View</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <EditSubscription ref="editSubscription" />
  </div>
</template>

<script>
import EditSubscription from '@/components/products/manufacturers/EditSubscription'
import { subscriptionCodeStatus } from '../../../const'
import ApiService from '@/services/CommonApiService.js'
import ManufacturerInput from '@/components/ManufacturerInput'
import moment from 'moment'
import swal from 'sweetalert'
export default {
  data() {
    return {
      moment,
      subscriptionCodeStatus,
      tableData: [],
      loading: false,
      filter: '',
      timer: '',
      addLoading: false
    }
  },
  components: {
    EditSubscription,
    ManufacturerInput
  },
  mounted: function() {
    this.getData()
  },
  computed: {
    statusFontClass() {
      return status => {
        let className = ''
        switch (status) {
          case 'Disabled':
            className = 'dark-grey-font'
            break
          case 'Approved':
            className = 'green-font'
            break
          default:
            className = 'red-font'
        }
        return className
      }
    }
  },
  watch: {
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getData, 500)
    },
    '$store.state.manufacturer.selectedManufacturer': function() {
      this.getData()
    }
  },
  methods: {
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    getData() {
      if (!this.$store.state.manufacturer.selectedManufacturer) return false
      this.loading = true
      ApiService.GetManufacturerCodesByManufacturerId(
        this.$store.state.manufacturer.selectedManufacturer.id
      )
        .then(response => {
          this.loading = false
          this.tableData = response.data.data.map(item => {
            return {
              ...item,
              expiryDateTime:
                item.expiryDateTime === '0001-01-01T00:00:00'
                  ? ''
                  : moment
                      .utc(item.expiryDateTime)
                      .tz(moment.tz.guess(true))
                      .format('YYYY-MM-DD HH:mm:ss'),
              createdDateTime: moment
                .utc(item.createdDateTime)
                .tz(moment.tz.guess(true))
                .format('YYYY-MM-DD HH:mm:ss'),
              status: this.calculateStatus(item)
            }
          })
          if (this.filter) {
            this.tableData = this.tableData.filter(item => {
              return (
                item.productNumber
                  .toLowerCase()
                  .indexOf(this.filter.toLowerCase()) > -1 ||
                item.productName
                  .toLowerCase()
                  .indexOf(this.filter.toLowerCase()) > -1
              )
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    add() {
      if (!this.$store.state.manufacturer.selectedManufacturer) return false
      this.addLoading = true
      ApiService.CreateManufacturerCode({
        manufacturerId: this.$store.state.manufacturer.selectedManufacturer.id
      })
        .then(response => {
          this.addLoading = false
          if (response.data.success) {
            this.getData()
          }
        })
        .catch(() => {
          this.addLoading = false
        })
    },
    approveCode(row) {
      this.loading = true
      ApiService.ApproveManufacturerCode({
        id: row.id
      })
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.getData()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    edit(row) {
      this.$refs.editSubscription.openDialog()
      this.$refs.editSubscription.form = JSON.parse(JSON.stringify(row))
    },
    calculateStatus(item) {
      if (
        item.expiryDateTime !== '0001-01-01T00:00:00' &&
        moment.utc(item.expiryDateTime).isBefore(moment.utc())
      ) {
        return 'Disabled'
      } else {
        if (item.isApproved) {
          return 'Approved'
        } else {
          return 'Trial'
        }
      }
    }
  }
}
</script>
